import {
  addDays,
  addMonths,
  endOfMonth,
  endOfQuarter,
  endOfYear,
  isEqual,
  startOfDay,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear
} from 'date-fns';

export function getDateRange(dates: Date[]): string | Date[] {
  if (dates.length !== 2) return dates;
  const first = startOfDay(dates[0]); // hack to remove any DST type issues
  const last = startOfDay(dates[1]); // hack to remove any DST type issues
  const now = startOfDay(new Date());

  if (isEqual(first, now) && isEqual(last, now)) return 'Today';
  else if (isEqual(first, addDays(now, -1)) && isEqual(last, addDays(now, -1))) return 'Yesterday';
  else if (isEqual(first, startOfWeek(now)) && isEqual(last, addDays(startOfWeek(now), 6)))
    return 'Current Week';
  else if (isEqual(first, addDays(now, -7)) && isEqual(last, now)) return 'Last Week';
  else if (
    isEqual(first, addDays(startOfWeek(now), -7)) &&
    isEqual(last, addDays(startOfWeek(now), -1))
  )
    return 'Previous Week';
  else if (isEqual(first, startOfMonth(now)) && isEqual(last, startOfDay(endOfMonth(now))))
    return 'Current Month';
  else if (isEqual(first, addMonths(now, -1)) && isEqual(last, now)) return 'Last Month';
  else if (
    isEqual(first, addMonths(startOfMonth(now), -1)) &&
    isEqual(last, startOfDay(endOfMonth(addMonths(now, -1))))
  )
    return 'Previous Month';
  else if (isEqual(first, startOfQuarter(now)) && isEqual(last, startOfDay(endOfQuarter(now))))
    return 'Current Quarter';
  else if (
    isEqual(first, startOfQuarter(addMonths(now, -3))) &&
    isEqual(last, startOfDay(endOfQuarter(addMonths(now, -3))))
  )
    return 'Previous Quarter';
  else if (isEqual(first, startOfYear(now)) && isEqual(last, startOfDay(endOfYear(now))))
    return 'Current Year';
  else if (isEqual(first, addMonths(now, -12)) && isEqual(last, now)) return 'Last Year';
  else if (
    isEqual(first, addMonths(startOfYear(now), -12)) &&
    isEqual(last, addMonths(startOfDay(endOfYear(now)), -12))
  )
    return 'Previous Year';
  else {
    return dates;
  }
}
